export default __webpack_public_path__ + "static/media/03.ff33e85c.jpg";